import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import { Web3ContextProvider } from './hooks/web3Context'
import reportWebVitals from './reportWebVitals'
import 'react-toastify/dist/ReactToastify.css'
ReactDOM.render(
  <Web3ContextProvider>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Web3ContextProvider>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
